function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { memo, useCallback, useRef } from 'react';
import { useElementSize, useRefGetter } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { RcPopper } from '../../hooks/popper';
import { useRegion, useRegionClick } from '../../hooks/region';
import { SliderDragger } from './SliderDragger';
import { SliderMark } from './SliderMark';
export var SliderContent = memo(function (props) {
  var _props$markList = props.markList,
      markList = _props$markList === void 0 ? [] : _props$markList,
      markListClassName = props.markListClassName,
      disabled = props.disabled,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      mode = props.mode,
      format = props.format,
      rangeStart = props.rangeStart,
      rangeEnd = props.rangeEnd,
      showStart = props.showStart,
      value = props.value,
      tooltipVisible = props.tooltipVisible,
      extra = _objectWithoutProperties(props, ["markList", "markListClassName", "disabled", "invalid", "mode", "format", "rangeStart", "rangeEnd", "showStart", "value", "tooltipVisible"]);

  var region = useRegion();
  var containerRef = useRef(null);
  var regionClick = useRegionClick(containerRef);
  var disableGetter = useRefGetter(disabled);
  var onClick = useCallback(function (e) {
    if (disableGetter()) {
      return;
    }

    regionClick(e);
  }, []);
  useElementSize(containerRef, function () {
    return true;
  }, function (size) {
    region.updateRegionSize({
      width: size.width,
      height: 0
    });
  });
  var markComps = markList.map(function (item) {
    return React.createElement(SliderMark, {
      key: typeof item === 'number' ? item : item.value,
      value: typeof item === 'number' ? item : item.value,
      tooltip: typeof item === 'number' ? '' : item.tooltip,
      placement: typeof item === 'number' ? 'center' : item.placement,
      markListClassName: markListClassName,
      format: format,
      invalid: invalid
    });
  });
  var cls = usePrefixCls('slider-content');
  var bgCls = usePrefixCls('slider-background', {
    disabled: disabled,
    invalid: invalid
  });
  var selectedCls = usePrefixCls('slider-selected', {
    disabled: disabled,
    invalid: invalid
  });
  var clickCls = usePrefixCls('slider-click', {
    disabled: disabled
  });
  return React.createElement(RcPopper, null, React.createElement("div", Object.assign({
    ref: containerRef,
    className: cls
  }, extra), React.createElement("div", {
    className: bgCls
  }), React.createElement("div", {
    className: selectedCls,
    style: {
      left: "".concat(rangeStart, "px"),
      right: "".concat(rangeEnd, "px")
    }
  }), markComps, React.createElement("div", {
    className: clickCls,
    onClick: onClick
  }), showStart && React.createElement(SliderDragger, {
    draggable: !disabled,
    name: "start",
    format: format,
    invalid: invalid,
    mode: mode,
    value: value[0],
    rangeEnd: rangeEnd,
    tooltipVisible: tooltipVisible
  }), React.createElement(SliderDragger, {
    draggable: !disabled,
    name: "end",
    format: format,
    invalid: invalid,
    mode: mode,
    value: Array.isArray(value) ? value[1] : value,
    rangeEnd: rangeEnd,
    tooltipVisible: tooltipVisible
  })));
});